import { Icon, IconName, Tag } from '@blueprintjs/core';
import {
  StartingMaterialPriceItem,
  buildAmount,
  buildAvailabilityDescription,
} from '@retro-ui/shared';

import cls from './PriceEntry.module.scss';

interface PriceEntryProps {
  entry: StartingMaterialPriceItem;
  title: string;
  icon: IconName;
}

export function PriceEntry(props: PriceEntryProps) {
  const { entry, title, icon } = props;

  const { price } = entry;
  const [amount, unit] = buildAmount(entry.amount);
  const availability = buildAvailabilityDescription(entry.availabilityTier);

  return (
    <div className={cls.entry}>
      <div className={cls.entryTitle}>
        <Icon icon={icon} /> <span>{title}</span>
      </div>
      <div className={cls.entryDetails}>
        <span>from </span>
        <span className={cls.entryPrice}>${price}</span>
        <span> for </span>
        <span className={cls.entryAmount}>
          {amount}
          {unit}
        </span>
      </div>
      <div className={cls.entryAvailability}>
        <Tag round large minimal icon="time">
          {availability}
        </Tag>
      </div>
    </div>
  );
}
